import { atom  } from "recoil";
import { recoilPersist } from "recoil-persist";



const {persistAtom} = recoilPersist({
    key: "sessionState",
    storage: sessionStorage,
});

export const userState = atom({
    key : "userState",
    default : {
        recent : [],
        favorites : []
    },
    effects_UNSTABLE : [persistAtom]
})
